import React,{ useState }  from "react";
import { connect } from "react-redux";
import { 
    Users,
    Activity,
    Zap,
    Clock,
 } from "lucide-react";
import SummaryHeader from "components/header/SummaryHeader";
import SummaryItem from "components/header/SummaryItem";
import SelectOption from "components/select/SelectOption";
import EmployeeDashBoard from "./components/EmployeeDashBoard";

const Productivity = () => {
    const [positionFilter, setPositionFilter] = useState(0);

    return (
        <div className="grid grid-cols-1">
            <div className="space-y-6 max-w-[1800px]">
                <SummaryHeader
                    title={"Team Productivity"}
                    icon={Activity}
                    description={"Monitor and optimize team performance hours"}
                    color={"blue"}
                    rightNav={
                        <SelectOption
                            placeholder="All Departments"
                            className=" w-[180px] bg-white/20 backdrop-blur-sm border border-white/30 [&_.ant-select-selection-item]:text-white"
                            options={[
                                { label: "All Departments", value: 0 },
                                { label: "Engineering", value: 1 },
                                { label: "Marketing", value: 2 },
                                { label: "Costumer Success", value: 3 },
                                { label: "Design", value: 4 },
                                { label: "Operations", value: 5 },
                            ]}
                            value={positionFilter}
                            onChange={setPositionFilter}
                        />
                    }
                >
                    <div className="summary-item-container">
                        <SummaryItem
                            title="Avg. Hours/Week"
                            icon={<Clock />}
                            display="8.2h"
                        />
                        <SummaryItem
                            title="Avg. Productivity"
                            icon={<Zap />}
                            display="85%" 
                        />
                        <SummaryItem
                            title="Total Hours This Week"
                            icon={<Users />}
                            display="204h" 
                        />
                    </div>
                </SummaryHeader>
                <>
                    <EmployeeDashBoard departmentFilter={positionFilter} />
                </>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Productivity);